import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './App.css';
import { ToastContainer } from 'react-toastify';
import AppRoutes from '@ui/layout/AppRoutes';
function App() {
    return (_jsxs("div", { children: [_jsx(AppRoutes, {}), _jsx(ToastContainer, { position: "top-right", newestOnTop: true, pauseOnHover: true, theme: "colored" })] }));
}
export default App;
